import React from 'react';

/**
 * W/L pills for session rankings (live + post-session tables).
 * @param {string} form — e.g. "WLWLW" (oldest → newest within the window)
 */
export function SessionRecentFormIndicators({ form, size = 'table' }) {
  if (!form || form.length === 0) {
    return <span className="text-xs text-text-muted">N/A</span>;
  }

  const pillClass =
    size === 'compact'
      ? 'inline-flex h-4 w-4 items-center justify-center rounded-full text-[10px] font-bold'
      : 'inline-flex h-6 w-6 items-center justify-center rounded-full text-xs font-semibold mr-1';

  return (
    <div className="flex flex-wrap items-center justify-center gap-0.5">
      {form.split('').map((result, index) => (
        <span
          key={index}
          className={`${pillClass} ${
            result === 'W'
              ? size === 'compact'
                ? 'bg-success-light text-success-dark'
                : 'border border-success bg-success-light text-success-dark'
              : size === 'compact'
                ? 'bg-danger-light text-danger-dark'
                : 'border border-danger bg-danger-light text-danger-dark'
          }`}
        >
          {result}
        </span>
      ))}
    </div>
  );
}
